import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=12c3288e&scoped=true"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"
import style0 from "./MoneyInput.vue?vue&type=style&index=0&id=12c3288e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3288e",
  null
  
)

export default component.exports